import React from "react";
import { T } from "./tokens";
import { Chevron, DiagramShell, Layer, rowChips } from "./primitives";

const FirmwareArchitecture = ({ title }) => {
  const W = 840;
  const x = 28;
  const w = W - 56;
  const innerX = x + 16;
  const innerW = w - 32;
  const gap = 12;
  const innerH = 86;
  const innerGap = 10;

  const payload = 72;
  const usf = 216;
  const p1 = usf + 40;
  const p2 = p1 + innerH + innerGap;
  const p3 = p2 + innerH + innerGap;
  const usfH = p3 + innerH + 16 - usf;
  const arch = usf + usfH + 24;

  return (
    <DiagramShell
      uid="firmware"
      viewBox={`0 0 ${W} ${arch + 102}`}
      title="UEFI UniversalPayload Firmware"
      subtitle="UniversalPayload · platform · silicon"
      label={title}
    >
      <Layer
        x={x}
        y={payload}
        w={w}
        h={118}
        theme={T.purple}
        title="PAYLOAD FIRMWARE"
      >
        {rowChips(["UEFI Payload", "Linux Payload"], {
          x: innerX,
          y: payload + 42,
          w: innerW,
          h: 52,
          gap,
          theme: T.purple,
        })}
      </Layer>
      <Chevron x={W / 2} y={payload + 124} />

      <Layer
        x={x}
        y={usf}
        w={w}
        h={usfH}
        theme={T.slate}
        title="UNIVERSAL SCALABLE FIRMWARE  ·  USF"
      >
        <Layer
          x={innerX}
          y={p1}
          w={innerW}
          h={innerH}
          theme={T.indigo}
          title="PLATFORM FIRMWARE"
        >
          {rowChips(
            [
              ["EDK2 PEIM based", "Platform Firmware"],
              ["U-Boot / coreboot", "SlimBoot / orboot"],
            ],
            {
              x: innerX + 12,
              y: p1 + 38,
              w: innerW - 24,
              h: 38,
              gap,
              theme: T.indigo,
            }
          )}
        </Layer>
        <Layer
          x={innerX}
          y={p2}
          w={innerW}
          h={innerH}
          theme={T.green}
          title="SOC FIRMWARE"
        >
          {rowChips(["IPFW integration layer for SoC"], {
            x: innerX + 12,
            y: p2 + 38,
            w: innerW - 24,
            h: 38,
            gap,
            theme: T.green,
          })}
        </Layer>
        <Layer
          x={innerX}
          y={p3}
          w={innerW}
          h={innerH}
          theme={T.purple}
          title="IP FIRMWARE"
        >
          {rowChips(["IP firmware from silicon vendors"], {
            x: innerX + 12,
            y: p3 + 38,
            w: innerW - 24,
            h: 38,
            gap,
            theme: T.purple,
          })}
        </Layer>
      </Layer>
      <Chevron x={W / 2} y={usf + usfH + 6} />

      <Layer x={x} y={arch} w={w} h={90} theme={T.amber} title="ARCHITECTURE">
        {rowChips(["x86", "Arm", "RISC-V", "MIPS"], {
          x: innerX,
          y: arch + 36,
          w: innerW,
          h: 40,
          gap,
          theme: T.amber,
        })}
      </Layer>
    </DiagramShell>
  );
};

export default FirmwareArchitecture;
